import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Collapse from 'syf-component-library/ui/atoms/Collapse';
import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { useState } from 'react';
import EnrichedTransactionSection from '../../../views/RecognizeTransactions/EnrichedSection';
import TransactionItem from '../TransactionItem';
const TableRowContainer = styled.div ``;
const RowContentContainer = styled.div `
  border-top: 1px solid ${({ theme }) => theme.colors.lightGrey};
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 72px;
  padding: ${({ theme: { spacing } }) => `${spacing.small}px ${spacing.base}px ${spacing.small}px ${spacing.large}px`};

  @media ${query.greaterThanMedium} {
    padding: 0 ${({ theme }) => theme.spacing.base}px;
  }
`;
const RenderTransactions = ({ transaction }) => {
    const [expand, setExpand] = useState(false);
    const toggleExpand = () => setExpand(prev => !prev);
    const { address, purchaseLocation, referenceNumber, transactionId } = transaction;
    const handleKeyPress = (e) => {
        const { key } = e;
        const ENTER_KEY = 'Enter';
        const SPACE_KEY = ' ';
        if (key === ENTER_KEY || key === SPACE_KEY) {
            toggleExpand();
        }
    };
    return (_jsxs(TableRowContainer, Object.assign({ "data-cy": "recurring-transaction-table-row" }, { children: [_jsx(RowContentContainer, Object.assign({ onClick: toggleExpand, onKeyPress: handleKeyPress, tabIndex: 0, role: "button", "data-testid": "txn-row-container", "data-type": "replacement card", "data-reason": "more info", "data-object": "button", "data-analytics": "clicktrackingevent" }, { children: _jsx(TransactionItem, { transaction: transaction, expand: expand }) })), _jsx(Collapse, Object.assign({ expand: expand, id: transactionId }, { children: _jsx(EnrichedTransactionSection, { address: address, purchaseLocation: purchaseLocation, referenceNumber: referenceNumber }) }))] })));
};
export default RenderTransactions;
//# sourceMappingURL=index.js.map